import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";

export type ExportFormat = "csv" | "xls" | "json";

const FORMAT_LABELS: Record<ExportFormat, string> = {
  csv: "CSV",
  xls: "Excel",
  json: "JSON",
};

interface ExportDropdownProps {
  baseUrl: string;
  formats?: ExportFormat[];
  title?: string;
  className?: string;
}

/** Generic export dropdown. Pair with a backend endpoint that uses the `export_records` utility. */
export const ExportDropdown = ({
  baseUrl,
  formats = ["csv", "xls", "json"],
  title = "Export",
  className,
}: ExportDropdownProps) => {
  const defaultFormat = formats[0];
  const separator = baseUrl.includes("?") ? "&" : "?";
  const buildUrl = (format: ExportFormat) => `${baseUrl}${separator}format=${format}`;

  return (
    <DropdownButtonGroup
      as={"a"}
      title={title}
      variant={"secondary"}
      className={className}
      href={buildUrl(defaultFormat)}
    >
      {formats.map((format) => (
        <DropdownItem key={format} href={buildUrl(format)}>
          {FORMAT_LABELS[format]}
        </DropdownItem>
      ))}
    </DropdownButtonGroup>
  );
};
